import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree, } from '@angular/router';
import { Observable } from 'rxjs';
import { SeoService } from 'src/app/service/seo/seo.service';

@Injectable( {
  providedIn: 'root',
} )
export class NavigationInterceptor implements CanActivate {
  constructor( private seoService: SeoService, private router: Router ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    const paramMapAsMap = new Map<string, string>();
    next.paramMap.keys.forEach( key => {
      paramMapAsMap.set( key, next.paramMap.get( key )! );
    } );

    // Query params (e.g. ?product=&category=&platform=) are tracked as custom page
    // event properties too, alongside the path params.
    const queryParams: { [ key: string ]: string } = {};
    next.queryParamMap.keys.forEach( key => {
      queryParams[ key ] = next.queryParamMap.get( key )!;
    } );

    // A `skipLocationChange` navigation moves router state without changing the
    // URL the visitor sees - the converter pages use one to render a random
    // color in place on a blank landing - so it is the same page view, not a
    // new one. Logging it fired every converter's event twice per landing.
    const silent = !!this.router.getCurrentNavigation()?.extras?.skipLocationChange;

    // ... and it must not rewrite the head either: the tool pages land on their curated title and
    // then fill themselves with a random value through such a navigation, which appended that
    // value to the title ("Hex Color Tool ... Woodgrain"). The pages that DO want a new head after
    // one (the colour and palette tools when the visible URL gains the value) call the service
    // themselves.
    this.seoService.seoAndAnalytics( state.url, paramMapAsMap, !silent, queryParams, !silent );

    return true;
  }
}
